import * as React from "react";
const SvgLamp = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.24 6.406A2.75 2.75 0 0 1 4.232 2.65l.5-.866A2.75 2.75 0 0 1 8.489.777l6.423 3.708.166-.02 6.205-.747a.75.75 0 0 1 .74 1.12l-6.5 11.258a.75.75 0 0 1-1.34-.08l-2.455-5.748-.066-.153-2.285-1.32v8.696l5.73 4.775a.75.75 0 1 1-.96 1.152l-4.77-3.975v2.399a.75.75 0 0 1-1.5 0v-2.399l-4.77 3.975a.75.75 0 1 1-.96-1.152l5.73-4.775V7.929L5.24 6.406Zm2.5-4.33 6.278 3.625-1.75 3.031-6.279-3.625A1.25 1.25 0 0 1 5.532 3.4l.5-.866a1.25 1.25 0 0 1 1.707-.458Zm5.514 7.947 1.72 4.024 5-8.66-4.345.523-2.374 4.114Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgLamp;
